export enum GenericEvents {
	BAG_UPDATE = 'bag_update',
	BAG_ERROR = 'bag_error',
	STOCK_TOTAL_ERROR = 'stock_total_error',
	STOCK_PARTIAL_ERROR = 'stock_partial_error',
	ADD_PROMO_CODE = 'add_promo_code',
	CLICK_VIEW_CART = 'click_view_cart',
	VIEW_SIMILARS = 'view_similars_show',
	CLOSE_FEEDBACK_NOTIFICATION = 'close_feedback_bag',
	CLICK_CART_LOGIN = 'click_login',
	CLICK_CART_REGISTRY = 'click_registry',
	VIEW_CART_LOGIN = 'login_show',
	VIEW_CART_REGISTRY = 'registry_show',
	CART_LOGIN_SUCCESS = 'login',
	CART_REGISTRY_SUCCESS = 'sign_up',
}

export enum BagErrorTypes {
	ADD_ITEM = 'bag-error-add-item',
	REMOVE_ITEM = 'bag-error-remove-item',
	TOTAL_ITEMS = 'bag-error-total-items',
	PREVIEW_ITEMS = 'bag-error-preview-items',
	PAGE_ITEMS = 'bag-error-page-items',
	CLEAR_ITEM = 'bag-error-clear-item',
}
